import type {Recipe} from './types';

export const pannaCottaFragole: Recipe = {
    id: 6,
    key: "pannaCottaFragole",
    pictures: [
        {index: 0, url: "https://www.lacucinaimperfetta.com/wp-content/uploads/2012/04/Panna-cotta-alle-fragole-9.jpg"},
    ],
    i18n: {
        IT: {
            title: "Panna Cotta alle Fragole",
            servings: "4 porzioni",
            ingredients: [
                "100 ml latte",
                "500 ml panna fresca",
                "100 g zucchero ",
                "3 fogli di gelatina (6 g) ",
                "0.5 baccello di vaniglia o il suo contenuto ",
                "Fragole",
            ],
            steps: [
                "Metti a bagno i fogli di gelatina in una pentola con dell'acqua fredda per alcuni minuti.",
                "In un'altra pentola, mescola il latte, lo zucchero, la panna e la vaniglia.",
                "Riscalda la miscela a fuoco medio, mescolando continuamente, fino a quando raggiunge una temperatura vicina all'ebollizione. Dovresti vedere delle bolle formarsi ai bordi e del vapore.",
                "Verifica che lo zucchero si sia completamente sciolto.",
                "Togli la pentola dal fuoco.",
                "Togli i fogli di gelatina dall'acqua e strizzali per eliminare l'acqua in eccesso.",
                "Aggiungi la gelatina alla pentola e mescola finché non si sarà completamente sciolta.",
                "Versa la miscela nei bicchieri o nei contenitori in cui servirai la panna cotta.",
                "Lascia raffreddare la panna cotta a temperatura ambiente, poi copri e metti in frigorifero fino a quando sarà solidificata.",
                "Una volta che la panna cotta si sarà solidificata, taglia delle fragole a fette e posizionalele sulla parte superiore di ogni porzione.",
            ],
        },
        EN: {
            title: "Strawberry Panna Cotta",
            servings: "4 servings",
            ingredients: [
                "100 ml milk",
                "500 ml fresh cream",
                "100 g sugar",
                "3 sheets of gelatin (6 g)",
                "0.5 vanilla pod or its contents",
                "Strawberries",
            ],
            steps: [
                "Soak the gelatin sheets in a pot with cold water for a few minutes.",
                "In another pot, mix the milk, sugar, cream, and vanilla.",
                "Heat the mixture over medium heat, stirring continuously, until it reaches a temperature close to boiling. You should see bubbles forming at the edges and some steam.",
                "Make sure the sugar has completely dissolved.",
                "Remove the pot from the heat.",
                "Remove the gelatin sheets from the water and squeeze to eliminate excess water.",
                "Add the gelatin to the pot and stir until it has completely dissolved.",
                "Pour the mixture into the glasses or containers in which you will serve the panna cotta.",
                "Let the panna cotta cool to room temperature, then cover and refrigerate until set.",
                "Once the panna cotta has set, slice some strawberries and place them on top of each portion.",
            ],
        },
        PL: {
            title: "Panna Cotta z Truskawkami",
            servings: "4 porcje",
            ingredients: [
                "100 ml mleka",
                "500 ml świeżej śmietany",
                "100 g cukru",
                "3 arkusze żelatyny (6 g)",
                "0,5 laski wanilii lub jej zawartość",
                "Truskawki",
            ],
            steps: [
                "Namocz arkusze żelatyny w garnku z zimną wodą na kilka minut.",
                "W innym garnku wymieszaj mleko, cukier, śmietanę i wanilię.",
                "Podgrzewaj mieszankę na średnim ogniu, ciągle mieszając, aż osiągnie temperaturę bliską wrzeniu. Powinny pojawić się bąbelki na brzegach i para.",
                "Upewnij się, że cukier całkowicie się rozpuścił.",
                "Zdejmij garnek z ognia.",
                "Wyjmij arkusze żelatyny z wody i wyciśnij nadmiar wody.",
                "Dodaj żelatynę do garnka i mieszaj, aż całkowicie się rozpuści.",
                "Wlej mieszankę do szklanek lub pojemników, w których będziesz serwować panna cottę.",
                "Pozwól panna cotcie ostygnąć do temperatury pokojowej, następnie przykryj i wstaw do lodówki, aż stężeje.",
                "Gdy panna cotta stężeje, pokrój truskawki w plastry i ułóż je na wierzchu każdej porcji.",
            ],
        },
    },
};
